import {convertCommercialUnit, TranslateService, Unit} from '@vdw/angular-component-library';
import {round} from 'lodash-es';

export abstract class CalculateDimensionsBasePipe {
  private readonly translate: TranslateService;

  protected constructor(translate: TranslateService) {
    this.translate = translate;
  }

  protected calculateDimensions(dimension: number, displayTechnicalUnit: boolean, commercialUnit: Unit): number {
    let result = 0;

    if (displayTechnicalUnit) {
      result = round(dimension);
    } else {
      result = round(
        convertCommercialUnit({
          from: {
            unit: Unit.MILLIMETER,
            value: dimension
          },
          to: commercialUnit
        }),
        2
      );
    }

    return result;
  }

  protected getUnitLabel(displayTechnicalUnit: boolean, technicalUnit: Unit, commercialUnit: Unit): string {
    return displayTechnicalUnit ? this.translate.instant(`GENERAL.UNIT.${Unit.getKeyFromValue(technicalUnit)}`) : this.translate.instant(`GENERAL.UNIT.${Unit.getKeyFromValue(commercialUnit)}`);
  }

  protected abstract transform(...args: any[]): string;
}
